/* Sort the complete filtered collection BEFORE pagination, not just the current page. */
(() => {
  if (window.wombatStockCatalogStarted) return;
  window.wombatStockCatalogStarted = true;
  const cache = new Map();
  let lastGrid;
  let run = 0;
  let activeCatalog;
  const baseURL = () => {
    const url = new URL(location.href);
    url.searchParams.delete('page');
    url.searchParams.delete('section_id');
    url.searchParams.delete('wombat_stock');
    url.searchParams.delete('wombat_brand');
    return url;
  };
  const pageURL = (page) => {
    const url = new URL(location.href);
    url.searchParams.delete('page');
    url.searchParams.delete('section_id');
    if (page > 1) url.searchParams.set('page', page);
    return url.pathname + url.search + '#product-grid';
  };
  function filterCatalog(cards, selection) {
    return cards.filter(card => {
      const rank = Number(card.dataset.stockRank);
      const preorder = card.dataset.catalogPreorder === 'true';
      if (selection.brand && card.dataset.catalogBrand !== selection.brand) return false;
      if (selection.stock === 'stock') return rank === 0 && !preorder;
      if (selection.stock === 'preorder') return preorder;
      if (selection.stock === 'soldout') return rank === 2;
      return true;
    });
  }
  function selectionFromURL() {
    const params = new URL(location.href).searchParams;
    return { stock: params.get('wombat_stock') || '', brand: params.get('wombat_brand') || '' };
  }
  function syncControls(cards, selection) {
    const stock = document.querySelector('[data-catalog-filter="stock"]');
    const brand = document.querySelector('[data-catalog-filter="brand"]');
    if (stock) { stock.value = selection.stock; stock.disabled = false; }
    if (brand) {
      const allLabel = brand.options[0].textContent;
      const brands = [...new Set(cards.map(card => card.dataset.catalogBrand).filter(Boolean))].sort((a,b) => a.localeCompare(b, 'zh-TW'));
      if (selection.brand && !brands.includes(selection.brand)) brands.push(selection.brand);
      brand.replaceChildren(new Option(allLabel, ''), ...brands.map(name => new Option(name, name)));
      brand.value = selection.brand;
      brand.disabled = false;
    }
    const reset = document.querySelector('[data-catalog-reset]');
    if (reset) reset.hidden = !selection.stock && !selection.brand;
    document.querySelectorAll('facet-filters-form form').forEach(form => {
      ['stock', 'brand'].forEach(key => {
        let input = form.querySelector(`[data-catalog-state="${key}"]`);
        if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = `wombat_${key}`; input.dataset.catalogState = key; form.append(input); }
        input.value = selection[key];
        input.disabled = !selection[key];
      });
    });
  }
  async function fetchPage(base, page, signal) {
    const url = new URL(base);
    url.searchParams.set('section_id', 'wombat-stock-catalog');
    url.searchParams.set('page', page);
    const response = await fetch(url, { signal, credentials: 'same-origin' });
    if (!response.ok) throw new Error('Catalog response failed');
    // A template keeps off-page images and scripts inert until a card is shown.
    const holder = document.createElement('template');
    holder.innerHTML = await response.text();
    const data = holder.content.querySelector('[data-wombat-catalog-page]');
    if (!data || Number(data.dataset.wombatCatalogPage) !== page) throw new Error('Invalid catalog page');
    return { total: Number(data.dataset.total), pages: Number(data.dataset.pages), cards: Array.from(data.querySelectorAll('template[data-product-id]')) };
  }
  async function loadCatalog(base) {
    const key = base.href;
    const cached = cache.get(key);
    if (cached && Date.now() - cached.time < 60000) return cached.cards;
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 25000);
    try {
      const first = await fetchPage(base, 1, controller.signal);
      const cards = [...first.cards];
      for (let page = 2; page <= first.pages; page++) {
        const next = await fetchPage(base, page, controller.signal);
        if (next.total !== first.total) throw new Error('Catalog changed during loading');
        cards.push(...next.cards);
      }
      const ids = new Set(cards.map(card => card.dataset.productId));
      if (cards.length !== first.total || ids.size !== cards.length) throw new Error('Incomplete catalog');
      cards.sort((a, b) => Number(a.dataset.stockRank) - Number(b.dataset.stockRank));
      cache.set(key, { cards, time: Date.now() });
      return cards;
    } finally { clearTimeout(timeout); }
  }
  function render(cards, grid, perPage, shouldFocus = false) {
    const selection = selectionFromURL();
    const sourceTotal = cards.length;
    syncControls(cards, selection);
    cards = filterCatalog(cards, selection);
    const pages = Math.max(1, Math.ceil(cards.length / perPage));
    const requested = Number(new URL(location.href).searchParams.get('page')) || 1;
    const page = Math.min(pages, Math.max(1, requested));
    const fragment = document.createDocumentFragment();
    cards.slice((page - 1) * perPage, page * perPage).forEach(card => fragment.append(card.content.cloneNode(true)));
    grid.replaceChildren(fragment);
    if (!cards.length) {
      const empty = document.createElement('li');
      empty.className = 'wombat-catalog-empty';
      empty.textContent = document.querySelector('[data-wombat-stock-note]').dataset.empty;
      grid.append(empty);
    }
    const collection = grid.parentElement;
    collection.querySelectorAll('.pagination-wrapper,[data-stock-pagination]').forEach(el => el.remove());
    const nav = document.createElement('nav');
    nav.dataset.stockPagination = '';
    nav.className = 'wombat-stock-pagination';
    nav.setAttribute('aria-label', '商品目錄分頁');
    if (pages > 1) {
      const addLink = (target, label) => {
        const link = document.createElement('a');
        link.href = pageURL(target);
        link.textContent = label;
        if (target === page) link.setAttribute('aria-current', 'page');
        nav.append(link);
      };
      if (page > 1) addLink(page - 1, '上一頁');
      const shown = new Set([1, pages, page - 1, page, page + 1]);
      let previous = 0;
      [...shown].filter(n => n > 0 && n <= pages).sort((a, b) => a - b).forEach(n => {
        if (previous && n > previous + 1) { const gap = document.createElement('span'); gap.textContent = '…'; nav.append(gap); }
        addLink(n, String(n)); previous = n;
      });
      if (page < pages) addLink(page + 1, '下一頁');
      collection.append(nav);
    }
    grid.dataset.stockSorted = 'true';
    grid.dataset.catalogTotal = String(cards.length);
    const note = document.querySelector('[data-wombat-stock-note]');
    if (note) note.textContent = (selection.stock || selection.brand ? note.dataset.resultsTemplate : note.dataset.allTemplate).replace('[count]', cards.length).replace('[total]', sourceTotal);
    ['ProductCount', 'ProductCountDesktop'].forEach(id => { const count = document.getElementById(id); if (count && note) count.textContent = note.dataset.countTemplate.replace('[count]', cards.length); });
    if (shouldFocus) { grid.tabIndex = -1; grid.focus({ preventScroll: true }); grid.scrollIntoView({ block: 'start', behavior: 'smooth' }); }
  }
  async function initialise() {
    const grid = document.querySelector('#product-grid');
    const component = document.querySelector('[data-wombat-stock-per-page]');
    if (!grid || !component || grid === lastGrid || !grid.matches('ul')) return;
    lastGrid = grid;
    const token = ++run;
    const base = baseURL();
    const perPage = Number(component.dataset.wombatStockPerPage) || 16;
    grid.setAttribute('aria-busy', 'true');
    const note = document.querySelector('[data-wombat-stock-note]');
    if (note) note.textContent = '正在依現貨庫存整理商品…';
    try {
      const cards = await loadCatalog(base);
      if (token !== run || !grid.isConnected || base.href !== baseURL().href) return;
      activeCatalog = { cards, grid, perPage, key: base.href };
      render(cards, grid, perPage);
    } catch (error) {
      if (token === run && note) note.textContent = '現貨排序暫時無法載入，目前顯示原始商品目錄；請重新整理再試。';
      console.warn('Inventory-aware catalog:', error.message);
    } finally { grid.removeAttribute('aria-busy'); }
  }
  document.addEventListener('click', event => {
    if (event.target.closest('[data-catalog-reset]') && activeCatalog) {
      const url = new URL(location.href);
      ['wombat_stock','wombat_brand','page'].forEach(key => url.searchParams.delete(key));
      history.pushState({ ...history.state }, '', url.pathname + url.search);
      render(activeCatalog.cards, activeCatalog.grid, activeCatalog.perPage);
      return;
    }
    const link = event.target.closest('[data-stock-pagination] a');
    if (!link || !activeCatalog || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    history.pushState({ ...history.state }, '', link.href);
    render(activeCatalog.cards, activeCatalog.grid, activeCatalog.perPage, true);
  });
  document.addEventListener('change', event => {
    const control = event.target.closest('[data-catalog-filter]');
    if (!control || !activeCatalog || !activeCatalog.grid.isConnected) return;
    const url = new URL(location.href);
    const key = `wombat_${control.dataset.catalogFilter}`;
    if (control.value) url.searchParams.set(key, control.value); else url.searchParams.delete(key);
    url.searchParams.delete('page');
    history.pushState({ ...history.state }, '', url.pathname + url.search);
    render(activeCatalog.cards, activeCatalog.grid, activeCatalog.perPage);
  });
  window.addEventListener('popstate', () => {
    if (activeCatalog && activeCatalog.grid.isConnected && activeCatalog.key === baseURL().href) render(activeCatalog.cards, activeCatalog.grid, activeCatalog.perPage);
  });
  const start = () => {
    const root = document.querySelector('[data-wombat-stock-per-page]');
    if (!root) return;
    new MutationObserver(initialise).observe(root, { childList: true, subtree: true });
    initialise();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
})();

